import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { ReactLenis } from 'lenis/react'
import Homepage from '../HomePage/HomePage'
import AboutPage from '../AboutPage/AboutPage'
import ServicePages from '../ServicePage/ServicePage'
import ProjectPage from '../ProjectPage/ProjectPage'
import ContactPage from '../ContactPage/ContactPage'

const AllRoute = () => {
  return (
    <ReactLenis root>
      <div className="App" id="scroll">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="home" element={<Homepage />} />

            <Route path="about" element={<AboutPage />} />
            <Route path="services" element={<ServicePages />} />

            <Route path="projects" element={<ProjectPage />} />

            <Route path="contact" element={<ContactPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </ReactLenis>
  )
}

export default AllRoute
